import ReactECharts from "echarts-for-react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";

export default function PieChart({ data }) {
    return (
        <Box>
            <Box
                sx={{
                    width: "100%",
                    // ✅ alturas más compactas
                    height: 550,
                    borderRadius: "40px",
                    border: "1px solid #222",
                    py: { xs: 2, md: 3 },
                    overflow: "hidden",
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                <Box sx={{ px: { xs: 2, md: 4 }, flexShrink: 0 }}>
                    <Typography variant="secTitle">Host source</Typography>
                </Box>

                {/* ✅ el área del chart ocupa el resto */}
                <Box
                    sx={{
                        flex: 1,
                        minHeight: 0, // importantísimo para que flex + height 100% no reviente
                        display: "flex",
                        alignItems: "center",
                        px: { xs: 1, md: 2 },
                    }}
                >
                    <Box sx={{ width: "100%", height: "100%" }}>
                        <PieChartDraw data={data} />
                    </Box>
                </Box>
            </Box>
        </Box>
    );
}

const PieChartDraw = ({ data = [] }) => {
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

    const fallbackData = [
    ];

    const option = {
        color: [
            "#20BC71",
            "rgba(32, 188, 113, 0.25)",
            "rgba(32, 188, 113, 0.75)",
            "rgba(32, 188, 113, 0.50)",
        ],
        series: [
            {
                type: "pie",
                radius: isSmallScreen ? ["10%", "80%"] : ["8%", "82%"],
                center: ["50%", isSmallScreen ? "52%" : "54%"],
                startAngle: 20,
                minAngle: 10,
                avoidLabelOverlap: true,
                itemStyle: { borderRadius: isSmallScreen ? 20 : 40 },

                label: {
                    show: true,
                    formatter: (params) =>
                        isSmallScreen
                            ? `{percent|${params.percent}}\n{gene|${params.data.gene || ""}}`
                            : `{percent|${params.percent}%}\n{gene|${params.data.gene || ""}}`,
                    rich: {
                        percent: {
                            fontSize: isSmallScreen ? 14 : 18,
                            color: "#000",
                            lineHeight: isSmallScreen ? 16 : 22,
                        },
                        value: {
                            fontSize: isSmallScreen ? 12 : 18,
                            color: "#000",
                            lineHeight: isSmallScreen ? 16 : 22,
                        },
                        gene: {
                            fontSize: isSmallScreen ? 10 : 14,   // más pequeño
                            color: "rgba(0,0,0,0.55)",          // más claro
                        },
                    },
                    position: isSmallScreen ? "inside" : "outside",
                    alignTo: "labelLine",
                    margin: isSmallScreen ? 2 : 6,
                },

                labelLine: {
                    show: !isSmallScreen,
                    length: 14,
                    length2: 20,
                    lineStyle: { color: "#111" },
                },

                data: (data?.length ? data : fallbackData).map(({ gene, value }) => ({
                    gene,
                    value,
                })),
            },
        ],
    };

    return <ReactECharts option={option} style={{ height: "100%", width: "100%" }} />;
};
